import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 */

export const sendAPBMailApi = async (
  osdId: string | undefined,
  params: any = {}
) => {
  try {
    const response = await axios.post(
      getUrl(ApiType.SEND_APB_MAIL).replace(":osdId", osdId ?? ""),
      params
    );
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.sendAPBMail, { badRequestOrder: "errorsFirst" });
  }
};
